import React from 'react'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'

import LocationItem from 'components_new/molecules/LocationItem'
import { useOptions, SelectType } from './utils'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useParams } from 'utils/hooks'
import { useTranslation } from 'language/translator'

interface DashboardTreeSelector {
  selected: string | null
  setSelected: (value: string | null) => void
  type?: SelectType
}

const DashboardTreeSelector = (props: DashboardTreeSelector) => {
  const { selected, setSelected, type = 'folder' } = props

  // if we are in a dashboard page,
  const { id } = useParams()
  const { account } = useAccountSettings()
  const { t } = useTranslation()

  const options = useOptions(account, type, id)

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <Icon fontSize="large" name="ArrowDownward" />
      </Box>
      <Box
        sx={{
          bgcolor: 'background.default',
          p: 1,
          maxHeight: 400,
          overflowY: 'auto'
        }}
      >
        <LocationItem
          item={{
            allow: true,
            id: 'dummy',
            name: t('dashboards', 'all_dashboards'),
            iconName: 'Dashboards'
          }}
          onClick={() => setSelected(null)}
          selected={selected ?? 'dummy'}
        />
        {options.map((option) => (
          <Box key={option.id}>
            <LocationItem
              indent={2}
              item={option}
              key={option.id}
              onClick={setSelected}
              selected={selected}
            />
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default DashboardTreeSelector
